/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для ссылок на склады на странице "Доставка товара". Открывает соответствующие вкладки.
   */
  app.DeliveryWhLinksView = app.View.extend({
    el: '.warehouse-links .link',
    events: {
      'click': 'linkToTab',
    },

    /**
     * Симулирует клик по соответствующей вкладке
     */
    linkToTab: function () {
      this.whLinkId = this.$el.data('content-id');
      var tabSelector = '.tab' + '[data-content-id="' + this.whLinkId + '"]'; // Селектор вкладки с нужным content-id
      $(tabSelector).click(); // Эмуляция клика, для вызова, уже определенных в его View, методов
    }
  });
})(jQuery);

}.call(window));